import { render } from "./DataSourceVideosTable.vue?vue&type=template&id=3586ebaa&ts=true"
import script from "./DataSourceVideosTable.vue?vue&type=script&lang=tsx"
export * from "./DataSourceVideosTable.vue?vue&type=script&lang=tsx"

import "./DataSourceVideosTable.vue?vue&type=style&index=0&id=3586ebaa&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__